import React, { useState, useEffect } from "react";
import "../../style/ResetPassword.css";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

    const [token, setToken] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // window.location.hash might look like: "#/reset-password?token=abcdef123..."
        const hash = window.location.hash; 
        // Remove the initial "#" and split on "?"
        const parts = hash.replace(/^#/, "").split("?");
        
        // parts[0] might be "/reset-password", parts[1] might be "token=abcdef123..."
        if (parts.length > 1) {
          const queryString = parts[1]; // "token=abcdef123..."
          const urlParams = new URLSearchParams(queryString);
          const tokenFromUrl = urlParams.get("token");
          if (tokenFromUrl) {
            setToken(tokenFromUrl);
            return;
          }
        }
        
        // If we get here, there's no valid token
        setError("Invalid or expired password reset link.");
      }, []);

    // Function to validate password strength
    const isValidPassword = (password) => {
        return (
            password.length >= 8 &&
            /[A-Z]/.test(password) &&
            /[0-9]/.test(password) &&
            /[\W]/.test(password)
        );
    };

    // Handle password reset submission
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (!isValidPassword(newPassword)) {
            setError("Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/backend/api/Settings/reset_password.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, newPassword }),
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage("Password successfully updated! Redirecting to login...");
                setTimeout(() => navigate("/login"), 3000);
            } else {
                setError(result.message);
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
        }
        setLoading(false);
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-box">
                <h1>Reset Password</h1>
                <p>Enter your new password below.</p>

                <form onSubmit={handleResetPassword}>
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    {error && <p className="error-message">{error}</p>}
                    {message && <p className="success-message">{message}</p>}
                    <button type="submit" disabled={loading}>
                        {loading ? "Resetting..." : "Reset Password"}
                    </button>
                </form>

                <p onClick={() => navigate("/login")} className="back-to-login">
                    Back to Login
                </p>
            </div>
        </div>
    );
};

export default ResetPassword;